/* //* Package imports */
import { useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { toast } from "react-toastify";

/* //* Service imports */
import { formatDate } from "../common/utils";
import { header } from "./cookieChecker";

/* //* URL imports */
import { exportLeadsData } from "./urls";

/* //* Style imports */
import "../styles/exportLeads.css";
import "react-toastify/dist/ReactToastify.min.css";


const ExportModal = (props) => {
  const currentDate = new Date();

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(currentDate.getMonth() - 1);
  oneMonthAgo.setDate(oneMonthAgo.getDate() + 1);

  const threeMonthAgo = new Date();
  threeMonthAgo.setMonth(currentDate.getMonth() - 3);

  const [state, setState] = useState([
    {
      startDate: oneMonthAgo,
      endDate: currentDate,
      key: "selection",
    },
  ]);

  const isWithin90Days = (startDate, endDate) => {
    const Difference_In_Time = Math.abs(
      endDate.getTime() - startDate.getTime()
    );
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return Difference_In_Days <= 90;
  };

  const handleExport = () => {
    let result = isWithin90Days(state[0].startDate, state[0].endDate);
    if (!result) {
      toast.error("Please select date duration within 90 days", {
        position: "bottom-right",
      });
      return;
    }
    const data = {
      start_date: formatDate(state[0].startDate),
      end_date: formatDate(state[0].endDate),
    };
    axios
      .post(exportLeadsData, data, header())
      .then(({data}) => {
        toast.success(data?.message, {
          position: "bottom-right",
        });
      })
      .catch((error) => {
        console.error(error?.message);
        toast.error(
          error?.response?.data?.message
            ? `Error fetching details: ${error?.response?.data?.message}`
            : "Email not sent",
          {
            position: "bottom-right",
          }
        );
      });
    props.setModalShow(false);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="containedModalTitleVcenter"
      centered
      className="exportModal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="containedModalTitleVcenter">
          Export Leads
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modalbody">
        <DateRangePicker
          onChange={(item) => setState([item.selection])}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          editableDateInputs={false}
          months={1}
          ranges={state}
          direction="horizontal"
        />
        <div className="text-right pb-2 ml-4">
          <Button
            variant="info"
            size="sm"
            className="ml-2 exportButton"
            onClick={() => handleExport()}
          >
            Export
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const ExportLeads = () => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Button
        className="exportLeadsButton"
        variant="primary"
        onClick={() => setModalShow(true)}
      >
        Export Leads
      </Button>
      <ExportModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        setModalShow={setModalShow}
      />
    </>
  );
};

export default ExportLeads;
